import { formatRent, getMonthlyFromWeeklyRent } from 'app/utils/numbers/helpers'

export const DEFAULT_STANDARD_BOND_DURATION_WEEKS = '4'

export const STANDARD_BOND_DURATION_4_WEEKS = '4'
export const STANDARD_BOND_DURATION_6_WEEKS = '6'
export const STANDARD_BOND_DURATION_1_MONTH = 'month'

const CORR_4_WEEKS_BOND_DURATION_ARRAY_INDEX = 4
const CORR_1_MONTH_BOND_DURATION_ARRAY_INDEX = 5
const CORR_6_WEEKS_BOND_DURATION_ARRAY_INDEX = 6

export const calcBondAmount = (
  weeklyRent: number,
  bondDurationWeeks: string,
  roundDown = false,
): string | number => {
  if (bondDurationWeeks === STANDARD_BOND_DURATION_1_MONTH) {
    return formatRent(getMonthlyFromWeeklyRent(weeklyRent), roundDown, 2)
  }
  return weeklyRent * Number(bondDurationWeeks)
}

export const convertBondDurationToCorrespondingArrayIndex = (
  bondDuration: string,
): number => {
  if (bondDuration === STANDARD_BOND_DURATION_1_MONTH) {
    return CORR_1_MONTH_BOND_DURATION_ARRAY_INDEX
  }
  return bondDuration === STANDARD_BOND_DURATION_6_WEEKS
    ? CORR_6_WEEKS_BOND_DURATION_ARRAY_INDEX
    : CORR_4_WEEKS_BOND_DURATION_ARRAY_INDEX
}

export const removeSpacesInText = (text: string): string => {
  return text.split(' ').join('')
}

interface SelectOption {
  guid: number
  name: string
  value?: number
}

export const leaseDetailsRentFrequency: SelectOption[] = [
  { guid: 0, name: 'Unset' },
  { guid: 1, name: '1 week' },
  { guid: 2, name: '2 weeks' },
  { guid: 3, name: '1 month' },
]

export const leaseLengthOptions: SelectOption[] = [
  { guid: 1, name: '12 months', value: 12 },
  { guid: 2, name: '6 months', value: 6 },
  { guid: 3, name: '52 weeks', value: 52 },
  { guid: 4, name: '26 weeks', value: 26 },
]

export const waterInclusionOptions: SelectOption[] = [
  { guid: 0, name: 'Unset' },
  { guid: 1, name: 'Excluded, renter pays all costs' },
  { guid: 2, name: 'Included, owner pays costs' },
  { guid: 3, name: 'Split, renter pays usage charges' },
]

export const FirstPaymentDefaultUnset = 0
export const FirstPaymentDefaultWeekly = 1
export const FirstPaymentDefaultFortnightly = 2
export const FirstPaymentDefaultMonthly = 3

export const WaterInclusionUnset = 0
export const WaterInclusionExcluded = 1
export const WaterInclusionIncluded = 2
export const WaterInclusionSplit = 3

export const RemainingBalanceTypeCalendarMonth =
  'calendar_month_net_first_payment'
export const RemainingBalanceTypeOneWeek = 'one_weeks_rent'

interface RemainingBalanceOption {
  guid: string
  name: string
}

export const remainingBalanceTypeOptions: RemainingBalanceOption[] = [
  {
    guid: RemainingBalanceTypeCalendarMonth,
    name: 'Calendar month net first payment',
  },
  { guid: RemainingBalanceTypeOneWeek, name: "One week's rent" },
]
